
import { ChampLibreGroup } from "./ChampLibreGroup";
import { DateLibreGroup } from "./DateLibreGroup";
import { IntituleLibreGroup } from "./IntituleLibreGroup";

export class ChampsLibresTexteDate {

  public txtLibre: ChampLibreGroup;
  public intLibre: IntituleLibreGroup;
  public dateLibre: DateLibreGroup;

  constructor() {
    this.txtLibre = new ChampLibreGroup();
    this.intLibre = new IntituleLibreGroup();
    this.dateLibre = new DateLibreGroup();
  }
}
